<!-- Filter Datatables -->
<section id="ngx-datatable-filter">
    <div class="row">
        <div class="col-12"></div>
        <div class="col-12">
            <div class="card">
                <div class="card-content">
                    <div class="card-body">
                        <!-- ngx-datatable-filter -->
                        <fieldset class="form-group">
                            <div class="row">
                                <div class="col-12 col-sm-12 col-md-6 col-lg-6 mb-1">
                                    <!-- <div class="btn-group enrollment-list-btn-info" role="group">
                                        <button class="btn enrollment-list-buttons cursor-pointer" type="button" *ngFor="let status of type_List"
                                            [ngClass]="{'btn-primary':activeTab==status?.name,'btn-outline-primary':activeTab!=status?.name}"
                                            (click)="activeEmployeeTab(status?.name)">{{status.displayname}}</button>
                                    </div> -->
									<div class="col">
										<button *ngIf="guideline_data" class="btn btn-outline-primary" (click)="openDynamicModal(guideline_data)">Campaigns Guideline</button>
									  </div>
                                </div>
								<div class="col-12 col-sm-12 col-md-6 col-lg-6 mt-2 mb-1">
									<div class="row-flex">
									  <div class="col-flex-2 mb-1 position-relative">
										<input id="ngx-filter-ref"
										  class="form-control form-control-sm d-inline-block width-300 ml-1 rounded-right shadow searchInput"
										  type="text"  placeholder="Search" #name [(ngModel)]="searchVal"
										  (keydown.enter)="filter(searchVal)"
										   />
										<button class="btn search-btn glow position-absolute" (click)="filter(searchVal)">
										  <i class="ft-search text-white cursor-pointer"></i>
										</button>
									  </div>
									  <div class="col-flex-2 mb-1" (click)="resetFilter()">
										<button class="btn btn-primary btn-block users-list-clear glow mb-0">Reset
										  <i class="ft-filter text-white cursor-pointer"></i>
										</button>
									  </div>
									  <div class="col-flex-2 mb-1"
										*ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
										<button type="reset" class="btn btn-primary btn-block users-list-clear glow mb-0"
										 placement="top" ngbTooltip="Add New" (click)="open(myModal,'','')">
										  +
										</button>
									  </div>
									</div>
								  </div>
                            </div>
                        </fieldset>
                        <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force"
                            [headerHeight]="50" [footerHeight]="50" rowHeight="auto" [limit]="limitRef" [rows]="rows"
                            [scrollbarH]="true" [columns]="columns" [externalPaging]="true" [count]="page.totalPages"
                            [offset]="page.pageNumber" (page)="pageChangeData($event)">
                            <ngx-datatable-column name="Name" prop="name" [width]="50">
                                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                                    <div class="d-flex align-items-center">
										<div class="avatar mr-1 ml-0 bg-primary">
											<div class="avatar-content">
											  {{ row?.name | shortName }}
											</div>
										  </div>
                                        <div class="cell-line-height cursor-pointer">
                                            <p class="font-medium-1 line-height-1 mb-0">
                                                {{ row.name }}
                                            </p>
                                        </div>
                                    </div>
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column name="Budget" prop="budget" [width]="10">
								<ng-template let-row="row" ngx-datatable-cell-template>
									<p>{{row?.budget}}</p>
								 </ng-template>
							</ngx-datatable-column>
                            <ngx-datatable-column name="Analytics" prop="analytics" [width]="50">
								<ng-template let-row="row" ngx-datatable-cell-template>
									<p>{{row?.analytics}}</p>
								 </ng-template>
							</ngx-datatable-column>
                            <ngx-datatable-column name="Target" prop="target" [width]="30">
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                   <p>{{row?.target}}</p>
                                </ng-template>
                            </ngx-datatable-column>
							<ngx-datatable-column name="Type" prop="type" [width]="30">
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                   <p>{{row?.type}}</p>
                                </ng-template>
                            </ngx-datatable-column>
							<ngx-datatable-column name="Status" prop="status" [width]="30">
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                   <p>{{row?.status}}</p>
                                </ng-template>
                            </ngx-datatable-column>
							<ngx-datatable-column name="Actions"
							*ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
							<ng-template let-row="row" ngx-datatable-cell-template>
							  <i class="ft-edit text-primary cursor-pointer mr-2" (click)="open(myModal,row?._id,row)"></i>
							  <i class="ft-trash-2 cursor-pointer danger"
								(click)="ConfirmColor(row._id)"></i>
							</ng-template>
						  </ngx-datatable-column>
                        </ngx-datatable>
                        <!-- ngx-datatable-filter -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!--/ Filter Datatables -->
<div class="d-flex justify-content-between align-items-center">
    <ngx-spinner></ngx-spinner>
</div>

<!-- --------- -->

<!----- -->
<div>
    <ng-template #myModal let-modal>
        <div class="modal-header">
            <h4 class="modal-title" *ngIf="!campaign_id">Add Campaign</h4>
            <h4 class="modal-title" *ngIf="campaign_id">Update Campaign</h4>
            <button type="button" class="close" (click)="modal.dismiss()">
                <span>&times;</span>
            </button>
        </div>
        <div class="modal-body">
			<div class="d-flex">
				<div class="col">
					<form [formGroup]="campaignForm">
						<fieldset class="form-group">
						  <label>Name</label>
						  <input
							type="text"
							class="form-control"
							formControlName="name"
							[(ngModel)]="campaign_model.name" [ngModelOptions]="{ standalone: true }"
							placeholder="Enter name"
						  />
						</fieldset>
						<fieldset class="form-group">
							<label>Type</label>
							<input
							  type="text"
							  class="form-control"
							  formControlName="type"
							  [(ngModel)]="campaign_model.type" [ngModelOptions]="{ standalone: true }"
							  placeholder="Enter type" 
							/>
						</fieldset>
						<fieldset class="form-group">
							<label>Start Date</label>
							<input
							  type="date"
							  class="form-control"
							  formControlName="startdate"
							  [ngModel]="campaign_model.startdate | date: 'yyyy-MM-dd'" [ngModelOptions]="{ standalone: true }"
							  [min]="minDate"
							/>
						</fieldset>
						<fieldset class="form-group">
							<label>End Date</label>
							<input
							  type="date"
							  class="form-control"
							  formControlName="enddate"
							  [ngModel]="campaign_model.enddate | date: 'yyyy-MM-dd'" [ngModelOptions]="{ standalone: true }"
							  [min]="minDate"
							/>
						</fieldset>
						<fieldset class="form-group">
							<label>Status</label>
							<input
							  type="text"
							  class="form-control"
							  formControlName="status"
							  [(ngModel)]="campaign_model.status" [ngModelOptions]="{ standalone: true }"
							  placeholder="Enter status"
							/>
						</fieldset>
						<fieldset class="form-group">
							<label>Budget</label>
							<input
							  type="number"
							  class="form-control"
							  formControlName="budget"
							  [(ngModel)]="campaign_model.budget" [ngModelOptions]="{ standalone: true }"
							  placeholder="Enter budget"
							/>
						</fieldset>
						<fieldset class="form-group">
							<label>Ownder</label>
							<input
							  type="text"
							  class="form-control"
							  formControlName="ownder"
							  [(ngModel)]="campaign_model.ownder" [ngModelOptions]="{ standalone: true }"
							  placeholder="Enter ownder"
							/>
						</fieldset>
						<fieldset class="form-group">
							<label>Target</label>
							<input
							  type="text"
							  class="form-control"
							  formControlName="target"
							  [(ngModel)]="campaign_model.target" [ngModelOptions]="{ standalone: true }"
							  placeholder="Enter target"
							/>
						</fieldset>
						<fieldset class="form-group">
							<label>Content</label>
							<input
							  type="text"
							  class="form-control"
							  formControlName="content"
							  [(ngModel)]="campaign_model.content" [ngModelOptions]="{ standalone: true }"
							  placeholder="Enter content"
							/>
						</fieldset>
						<fieldset class="form-group">
							<label>Goals</label>
							<input
							  type="text"
							  class="form-control"
							  formControlName="goals"
							  [(ngModel)]="campaign_model.goals" [ngModelOptions]="{ standalone: true }"
							  placeholder="Enter goals"
							/>
						</fieldset>
						<fieldset class="form-group">
							<label>KPI</label>
							<input
							  type="text"
							  class="form-control"
							  formControlName="kpi"
							  [(ngModel)]="campaign_model.kpi" [ngModelOptions]="{ standalone: true }"
							  placeholder="Enter kpi"
							/>
						</fieldset>
					</form>
				</div>
				<div class="col">
					<form [formGroup]="campaignForm">
					<fieldset class="form-group">
						<label>URl</label>
						<input
						  type="text"
						  class="form-control"
						  formControlName="url"
						  [(ngModel)]="campaign_model.url" [ngModelOptions]="{ standalone: true }"
						  placeholder="Enter url"
						/>
					</fieldset>
					<fieldset class="form-group">
						<label>Tracking Url</label>
						<input
						  type="text"
						  class="form-control"
						  formControlName="trackingurl"
						  [(ngModel)]="campaign_model.trackingurl" [ngModelOptions]="{ standalone: true }"
						  placeholder="Enter trackingurl"
						/>
					</fieldset>
				
					<fieldset class="form-group">
						<label>Results</label>
						<input
						  type="text"
						  class="form-control"
						  formControlName="results"
						  [(ngModel)]="campaign_model.results" [ngModelOptions]="{ standalone: true }"
						  placeholder="Enter results"
						/>
					</fieldset>
					<fieldset class="form-group">
						<label>Analytics</label>
						<input
						  type="text"
						  class="form-control"
						  formControlName="analytics"
						  [(ngModel)]="campaign_model.analytics" [ngModelOptions]="{ standalone: true }"
						  placeholder="Enter analytics"
						/>
					</fieldset>
					<fieldset class="form-group">
						<label>Attachments</label>
						<input
						  type="text"
						  class="form-control"
						  formControlName="attachments"
						  [(ngModel)]="campaign_model.attachments" [ngModelOptions]="{ standalone: true }"
						  placeholder="Enter attachments"
						/>
					</fieldset>
					<fieldset class="form-group">
						<label>References</label>
						<input
						  type="text"
						  class="form-control"
						  formControlName="references"
						  [(ngModel)]="campaign_model.references" [ngModelOptions]="{ standalone: true }"
						  placeholder="Enter references"
						/>
					</fieldset>
					<!-- <fieldset class="form-group">
						<label>Tag</label>
						<ng-select
						  [items]="tag_list"
						  bindLabel="displayname"
						  bindValue="_id"
						  [closeOnSelect]="false"
						  placeholder="Select one"
						  [(ngModel)]="selected_tag"
						  [ngModelOptions]="{ standalone: true }"
						  (change)="getTagId($event)"
						>
						</ng-select>
					  </fieldset> -->
				
					<fieldset class="form-group">
						<label>Description</label>
						<textarea
						  formControlName="description"
						  [(ngModel)]="campaign_model.description" [ngModelOptions]="{ standalone: true }"
						  id="hidden-label-form-6"
						  rows="3"
						  class="form-control"
						  name="comment2"
						  placeholder="Enter description"
						></textarea>
					  </fieldset>
					<fieldset class="form-group">
					  <label>Notes</label>
					  <textarea
						formControlName="notes"
						[(ngModel)]="campaign_model.notes" [ngModelOptions]="{ standalone: true }"
						id="hidden-label-form-6"
						rows="3"
						class="form-control"
						name="comment2"
						placeholder="Enter notes"
					  ></textarea>
					</fieldset>
					<fieldset class="form-group">
						<label>Admin Notes</label>
						<textarea
						  formControlName="admin_notes"
						  [(ngModel)]="campaign_model.admin_notes" [ngModelOptions]="{ standalone: true }"
						  id="hidden-label-form-6"
						  rows="4"
						  class="form-control"
						  name="comment2"
						  placeholder="Enter admin notes"
						></textarea>
					  </fieldset>
				  </form>
				</div>
			</div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-primary" (click)="submit()">Submit</button>
            <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
        </div>
    </ng-template>
</div>

